export const setTableWidths = (tablesContent) => {
  Object.keys(tablesContent).forEach((table) => {
    const widthData = tablesContent[table].match(/colgroup.*?\/colgroup/);
    if (widthData) {
      const widthCount = (widthData[0].match(/width/g) || []).length;
      const widthSearch = /width.*?"/g;
      if (widthCount > 0) {
        tablesContent[table] = tablesContent[table].replace(
          widthSearch,
          `width:${100 / Math.max(widthCount, 1)}%"`
        );
      }
    }
  });
  return tablesContent;
};
